module.exports = __webpack_public_path__ + "img/trademark-circle.e3bd4ad8.svg";